import * as React from 'react';

import * as styles from './index.css';

export interface IGalleryPromoTitleProps {
  title: string | null;
}

export class GalleryPromoTitle extends React.Component<IGalleryPromoTitleProps, {}> {
  public render() {
    return (
      this.props.title
      ? <div className={styles['title']}>
          {this.props.title}
        </div>
      : null
    );
  }
}
